import { Language as GeneratedLanguage } from 'types/schema';

export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const KAMEREO_SUPPLIER_ID = 654;
export const PHONE_NUMBER = 'tel:+84812463727';

// Không gắn mã quốc gia: link /sa/ (Ả Rập Saudi) mở trên Apple ID Việt Nam báo "No Longer Available"
export const APP_STORE_URL = 'https://apps.apple.com/app/id1469505654';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=vn.kamereo.buyer&hl=en_US&gl=US';

export const commonDimensions = {
  MAX_WIDTH_CONTAINER: 1392,
};

export enum ExtendedLanguage {
  Alternate = GeneratedLanguage.En,
}

export const LANGUAGES = {
  ...GeneratedLanguage,
  ...ExtendedLanguage,
};
